/**
 * HRIndicatorsPage — Indicateurs RH détaillés (effectifs H/F, turnover, ancienneté, etc.)
 * Réutilise le composant KPIDashboard existant.
 */
import DashboardLayout from '../components/layout/DashboardLayout';
import KPIDashboard from '../components/KPIDashboard';
import { BarChart3 } from 'lucide-react';

export default function HRIndicatorsPage() {
  return (
    <DashboardLayout>
      <div className="mx-auto max-w-7xl space-y-6" data-testid="hr-indicators-page">
        <div>
          <h1 className="text-3xl font-semibold tracking-tight text-ink-900 flex items-center gap-2">
            <BarChart3 className="h-7 w-7 text-brand" />
            Indicateurs RH
          </h1>
          <p className="mt-1 text-sm text-ink-500">
            Pilotage opérationnel : effectifs, parité H/F, turnover, ancienneté et alertes RH.
          </p>
        </div>
        <KPIDashboard />
      </div>
    </DashboardLayout>
  );
}
